<div class="container fw-b">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>
</div>

<!-- Payment Status Alert -->
<div class="container mt-3" *ngIf="paymentStatus">
  <div class="alert" [ngClass]="{
    'alert-success': paymentStatus === 'success',
    'alert-warning': paymentStatus === 'cancel',
    'alert-danger': paymentStatus === 'error'
  }" role="alert">
    <div class="d-flex align-items-center">
      <div class="me-3">
        <i class="fas" [ngClass]="{
          'fa-check-circle': paymentStatus === 'success',
          'fa-exclamation-triangle': paymentStatus === 'cancel',
          'fa-times-circle': paymentStatus === 'error'
        }"></i>
      </div>
      <div>
        <strong *ngIf="paymentStatus === 'success'">Payment Successful!</strong>
        <strong *ngIf="paymentStatus === 'cancel'">Payment Cancelled</strong>
        <strong *ngIf="paymentStatus === 'error'">Payment Failed</strong>
        <div *ngIf="paymentStatus === 'success'">Your payment has been processed successfully. You will receive a confirmation email shortly.</div>
        <div *ngIf="paymentStatus === 'cancel'">Your payment was cancelled. You can try again or choose a different payment method.</div>
        <div *ngIf="paymentStatus === 'error'">There was an error processing your payment. Please try again or contact support if the problem persists.</div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4 mb-5 address-list-wrapper">
  <div class="address-header">
    <h2 class="page-title">Shipping Address</h2>
    <button class="btn-add-address" (click)="navigatetoAdd()">
      <i class="fa fa-plus mr-2"></i>Add New Address
    </button>
  </div>
  
  <div class="address-cards-container">
    <div class="address-card" *ngFor="let item of listAddressData" 
         [class.primary-address]="item?.isPrimary"
         [class.selected-address]="selectedAddressId === item?._id">
      
      <!-- Radio button for selection -->
      <input
        type="radio"
        name="add"
        [readonly]="!item?.isServiceable"
        (change)="getChackBox($event.target.checked, item._id, item.isServiceable)"
        class="address-radio"
        *ngIf="getEndUrlSegment() == 'list-address-customer'"
        [checked]="selectedAddressId === item?._id"
      />
      
      <div class="address-card-content">
        <!-- Left: Address Details -->
        <div class="address-details">
          <div class="address-name">
            <i class="fa fa-user mr-2"></i>
            {{ item?.firstName }} {{ item?.lastName }}
          </div>
          
          <div class="address-info">
            <div class="info-row">
              <i class="fa fa-map-marker mr-2"></i>
              <span>{{ item?.addressLine1 }}{{ item?.addressLine2 ? ', ' + item?.addressLine2 : '' }}</span>
            </div>
            
            <div class="info-row">
              <i class="fa fa-location-arrow mr-2"></i>
              <span>{{ item?.zipCode }}</span>
            </div>
            
            <div class="info-row">
              <i class="fa fa-phone mr-2"></i>
              <span>{{ item?.countryCode | phoneFormat }}-{{ item?.mobileNumber | phoneFormat }}</span>
            </div>
          </div>
          
          <div class="address-badge" *ngIf="item?.isPrimary">
            <i class="fa fa-star mr-1"></i>Primary Address
          </div>
        </div>
        
        <!-- Right: Actions -->
        <div class="address-actions">
          <button class="action-btn edit-btn" (click)="navigateToEdit(item?._id)">
            <i class="fa fa-edit mr-2"></i>Edit
          </button>
          
          <button class="action-btn delete-btn" *ngIf="!item?.isPrimary"
                  (click)="addressModals(item?._id, item?.isPrimary)">
            <i class="fa fa-trash mr-2"></i>Delete
          </button>
          
          <button class="btn-set-primary" 
                  [disabled]="item?.isPrimary"
                  [class.is-primary]="item?.isPrimary"
                  (click)="setPrimaryAddress(item?._id)">
            <i class="fa" [ngClass]="item?.isPrimary ? 'fa-check-circle' : 'fa-circle-o'" aria-hidden="true"></i>
            {{ item?.isPrimary ? "Primary Address" : "Set as Primary" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Service Not Available Message -->
    <div class="alert alert-warning" *ngIf="!availiableInAddress">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      Service not available at this address. Please select a different one.
    </div>
    
    <!-- Loading State -->
    <app-table-loader
      [isTable]="'ADDRESS'"
      [isLoading]="isLoading"
      [notFoundData]="notFoundData"
      [colspan]="10"
    >
    </app-table-loader>
  </div>
  
  <!-- Continue Button -->
  <div class="continue-section" *ngIf="getEndUrlSegment() == 'list-address-customer'">
    <button class="btn-continue"
            [disabled]="!newAddressId"
            (click)="navigateToOrderOverview()">
      <i class="fa fa-arrow-right mr-2"></i>Continue with this Address
    </button>
  </div>
</div>

<div
  class="modal fade"
  id="addressModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content ggg" style="width: 77%">
      <div class="d-flex justify-content-center mt-5 mb-4" id="book">
        <img
          class="for-img1"
          style="height: 100%; width: 18%"
          src="assets/latest/logoutui.png"
          alt="login form"
          class="img-fluid"
        />
      </div>
      <h2
        class="modal-title d-flex justify-content-center okay"
        style="color: #263238"
      >
        Are you sure you want to delete <br />
        this address?
      </h2>
      <div class="modal-body d-flex justify-content-center mb-4">
        <button type="button" class="btn btntt1" data-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btntt ml-3"
          data-dismiss="modal"
          (click)="deleteAddress()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<address-pop-up
  *ngIf="showAddress"
  [addressData]="addressData"
  (closeModal)="closeModals()"
></address-pop-up>
<payment-status
  *ngIf="paymentStatus"
  [paymentStatus]="paymentStatus"
></payment-status>

<!-- </div> -->
